import { render, staticRenderFns } from "./QRegistration.vue?vue&type=template&id=781de754"
import script from "./QRegistration.vue?vue&type=script&lang=js"
export * from "./QRegistration.vue?vue&type=script&lang=js"
import style0 from "./QRegistration.vue?vue&type=style&index=0&id=781de754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports